import type { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import type { ComponentRef, EmbeddedViewRef, EventEmitter } from '@angular/core';

import type { Observable } from 'rxjs';

import type { NotificationStyle } from './notification-config';

export abstract class NotificationHostBase {
  public abstract hostClick: EventEmitter<any>;
  public abstract topButtonClick: EventEmitter<void>;
  public abstract afterClosed: Observable<any>;
  public abstract beforeClose: Observable<any>;

  public abstract setStyle(style: NotificationStyle): void;

  public abstract close(): void;

  public abstract attachTemplatePortal<T>(portal: TemplatePortal<T>): EmbeddedViewRef<T>;

  public abstract attachComponentPortal<T>(portal: ComponentPortal<T>): ComponentRef<T>;
}
